module.exports = __webpack_public_path__ + "static/media/wt-logo.639d9624.png";